module.exports = __webpack_public_path__ + "static/doctor-app@2x-ee6d93df970fdd77f6a7b490e8900975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/doctor-app@2x.jpg
// module id = 877
// module chunks = 71833740541355 256871573202158